import {
  MDBBtn, MDBBtnGroup, MDBCheckbox, MDBChipsInput, MDBDatepicker, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBFile, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader,
  MDBModalTitle, MDBPopconfirm,
  MDBPopconfirmMessage, MDBPopover, MDBPopoverBody, MDBPopoverHeader, MDBRadio, MDBSelect, MDBTable, MDBTableBody, MDBTableHead, MDBTabs, MDBTabsContent, MDBTabsItem,
  MDBTabsLink, MDBTabsPane, MDBTextArea
} from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import PhoneBlue from "../components/images/Cell.svg";
import phoneImageActive from "../components/images/Phone_System_active.svg";
import arrow from "../components/images/arrow_ic.svg";
import LaptopOrange from "../components/images/laptop_orange.svg";
import Location from "../components/images/location_red.svg";
import remove from "../components/images/remove.svg";
import voicemail from "../components/images/voicemail_active.svg";
import MainLinks from "../components/navlinks/MainLinks";

import { MDBDatatable } from "mdb-react-ui-kit";
import { getStreamsProductName } from "../apiclients/CommonUtils";

function IpPopups(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [modal1, setModal1] = useState(false);
  const toggleModal1 = () => setModal1(!modal1);

  const [modal2, setModal2] = useState(false);
  const toggleModal2 = () => setModal2(!modal2);

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);

  const [pagingGroupModal, setPagingGroupModal] = useState(false);
  const toggleShow2 = () => setPagingGroupModal(!pagingGroupModal);

  const [addBLF, setAddBLF] = useState(false);
  const toggleShow5 = () => setAddBLF(!addBLF);

  const [RemoveBLFGroup, setRemoveBLFGroup] = useState(false);
  const ToggleRemoveBLF = () => setRemoveBLFGroup(!RemoveBLFGroup);

  const [AddACDQueue, setAddACDQueue] = useState(false);
  const toggleShow9 = () => setAddACDQueue(!AddACDQueue);

  const [Add911Location, setAdd911Location] = useState(false);
  const toggleShow25 = () => setAdd911Location(!Add911Location);

  const [Adduser, setAdduser] = useState(false);
  const toggleShow20 = () => setAdduser(!Adduser);

  const [AddAutoAttendant, setAddAutoAttendant] = useState(false);
  const toggleShow11 = () => setAddAutoAttendant(!AddAutoAttendant);

  const [AddHuntGroup, setAddHuntGroup] = useState(false);
  const toggleShow10 = () => setAddHuntGroup(!AddHuntGroup);

  const [replaceDevice, setReplaceDevice] = useState(false);
  const toggleShow7 = () => setReplaceDevice(!replaceDevice);

  const [AddExternalNumbers, setAddExternalNumbers] = useState(false);
  const toggleShow42 = () => setAddExternalNumbers(!AddExternalNumbers);

  const [AddUsers, setAddUsers] = useState(false);
  const toggleShow13 = () => setAddUsers(!AddUsers);

  const [TabSwitchWarn, setTabSwitchWarn] = useState(false);
  const TabSwitch = () => setTabSwitchWarn(!TabSwitchWarn);

  const [ConfirmUserChanges, setConfirmUserChanges] = useState(false);
  const toggleShowConfirm = () => setConfirmUserChanges(!ConfirmUserChanges);

  const [ConfirmUserChanges2, setConfirmUserChanges2] = useState(false);
  const toggleShowConfirm2 = () => setConfirmUserChanges2(!ConfirmUserChanges2);

  const [blfGroupModal, setBlfGroupModal] = useState(false);
  const [removePageModal, setRemovePageModal] = useState(false);
  const [removeDevice, setRemoveDevice] = useState(false);
  const [removeBLF, setRemoveBLF] = useState(false);
  const [Schedule, setSchedule] = useState(false);
  const [VoiceMail, setVoiceMail] = useState(false);
  const [HuntGrouppreAnouncement, setHuntGrouppreAnouncement] = useState(false);
  const [AddSupervisors, setAddSupervisors] = useState(false);
  const [AddAgents, setAddAgents] = useState(false);
  const [AddHoliday, setAddHoliday] = useState(false);
  const [BillingGroup, setBillingGroup] = useState(false);
  const [AddLocation, setAddLocation] = useState(false);
  const [AddLocationWeekly, setAddLocationWeekly] = useState(false);
  const [RemoveLocation, setRemoveLocation] = useState(false);
  const [MoveUserLocation, setMoveUserLocation] = useState(false);
  const [Remove911Location, setRemove911Location] = useState(false);
  const [ChangeCallerID, setChangeCallerID] = useState(false);
  const [ChangeCallingPermissions, setChangeCallingPermissions] = useState(false);
  const [ChangeLocation, setChangeLocation] = useState(false);
  const [ChangeBillingGroup, setChangeBillingGroup] = useState(false);
  const [EnableorDisableanaddOn, setEnableorDisableanaddOn] = useState(false);
  const [EnableorDisableanaddOnOff, setEnableorDisableanaddOnOff] = useState(false);
  const [ChangeSeatPlan, setChangeSeatPlan] = useState(false);
  const [ChangePermissionRole, setChangePermissionRole] = useState(false);
  const [ConfigureWebIntegration, setConfigureWebIntegration] = useState(false);
  const [AddToGroup, setAddToGroup] = useState(false);
  const [AddToGroup2, setAddToGroup2] = useState(false);
  const [AddToGroup3, setAddToGroup3] = useState(false);
  const [ResetPassword, setResetPassword] = useState(false);
  const [SendWelcomeEmail, setSendWelcomeEmail] = useState(false);
  const [RemoveUser, setRemoveUser] = useState(false);
  const [EditExternalNumbers, setEditExternalNumbers] = useState(false);
  const [AddSpeedDial, setAddSpeedDial] = useState(false);
  const [EditSpeedDial, setEditSpeedDial] = useState(false);
  const [AddUserGroup, setAddUserGroup] = useState(false);
  const [RoutingPlans, setRoutingPlans] = useState(false);
  const [AddSequenceButton, setAddSequenceButton] = useState(false);
  const [AddSequence, setAddSequence] = useState(false)

  const toggleShow54 = () => setAddSequence(!AddSequence);

  const toggleShow49 = () => setAddTeamButton(!AddTeamButton);
  const [AddTeamButton, setAddTeamButton] = useState(false);

  const [AddAdminRole, setAddAdminRole] = useState(false);
  const toggleShow51 = () => setAddAdminRole(!AddAdminRole);

  const [RemoveAdminRole, setRemoveAdminRole] = useState(false);
  // const [AddAdminRole, setAddAdminRole] = useState(false);

  const toggleShow = () => setBlfGroupModal(!blfGroupModal);
  const toggleShow3 = () => setRemovePageModal(!removePageModal);
  const toggleShow4 = () => setRemoveDevice(!removeDevice);
  const toggleShow6 = () => setRemoveBLF(!removeBLF);
  const toggleShow8 = () => setSchedule(!Schedule);
  const toggleShow14 = () => setVoiceMail(!VoiceMail);
  const toggleShow15 = () =>
    setHuntGrouppreAnouncement(!HuntGrouppreAnouncement);
  const toggleShow16 = () => setAddSupervisors(!AddSupervisors);
  const toggleShow17 = () => setAddAgents(!AddAgents);
  const toggleShow18 = () => setAddHoliday(!AddHoliday);
  const toggleShow19 = () => setBillingGroup(!BillingGroup);
  const toggleShow21 = () => setAddLocation(!AddLocation);
  const toggleShow22 = () => setAddLocationWeekly(!AddLocationWeekly);
  const toggleShow23 = () => setRemoveLocation(!RemoveLocation);
  const toggleShow24 = () => setMoveUserLocation(!MoveUserLocation);
  const toggleShow26 = () => setRemove911Location(!Remove911Location);
  const toggleShow27 = () => setChangeCallerID(!ChangeCallerID);
  const toggleShow28 = () =>
    setChangeCallingPermissions(!ChangeCallingPermissions);
  const toggleShow29 = () => setChangeLocation(!ChangeLocation);
  const toggleShow30 = () => setChangeBillingGroup(!ChangeBillingGroup);
  const toggleShow31 = () => setEnableorDisableanaddOn(!EnableorDisableanaddOn);
  const toggleShow32 = () =>
    setEnableorDisableanaddOnOff(!EnableorDisableanaddOnOff);
  const toggleShow33 = () => setChangeSeatPlan(!ChangeSeatPlan);
  const toggleShow34 = () => setChangePermissionRole(!ChangePermissionRole);
  const toggleShow35 = () =>
    setConfigureWebIntegration(!ConfigureWebIntegration);
  const toggleShow36 = () => setAddToGroup(!AddToGroup);
  const toggleShow37 = () => setAddToGroup2(!AddToGroup2);
  const toggleShow38 = () => setAddToGroup3(!AddToGroup3);
  const toggleShow39 = () => setResetPassword(!ResetPassword);
  const toggleShow40 = () => setSendWelcomeEmail(!SendWelcomeEmail);
  const toggleShow41 = () => setRemoveUser(!RemoveUser);
  const toggleShow43 = () => setEditExternalNumbers(!EditExternalNumbers);
  const toggleShow45 = () => setEditSpeedDial(!EditSpeedDial);
  const toggleShow46 = () => setAddUserGroup(!AddUserGroup);
  const toggleShow47 = () => setRoutingPlans(!RoutingPlans);
  const toggleShow48 = () => setAddSequenceButton(!AddSequenceButton);
  const toggleShow44 = () => setAddSpeedDial(!AddSpeedDial);

  const toggleShow50 = () =>
    setAddUserFromAnotherAccount(!AddUserFromAnotherAccount);
  const [AddUserFromAnotherAccount, setAddUserFromAnotherAccount] =
    useState(false);

  const toggleShow52 = () => setRemoveAdminRole(!RemoveAdminRole);

  const basicData = {
    columns: ["Designation", "Model", "MAC Address"],
    rows: [
      ["IP Phone 1", "Poly VVX 601", "0004F21F3434"],
      ["IP Phone 2", "-", "-"],
    ],
  };

  const streamsProductName = getStreamsProductName();

  const [basicActive, setBasicActive] = useState("tab1");

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  const WeeklySchedule = {
    columns: ["Name", "Position", "Remove"],
    rows: [
      [
        "4th of July",
        "From: 07/04/2023 12:00 AM To: 07/04/2023 11:59 PM",
        <i className="fas fa-xmark text-primary text-end" alt="Profile"></i>,
      ],
      [
        "Christmas",
        "From: 12/24/2023 12:00 AM To: 12/26/2023 11:59 PM",
        <i className="fas fa-xmark text-primary" alt="Profile" ></i>,
      ],
    ],
  };

  const advancedData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Description", field: "position" },
      { label: "Remove", field: "age", sort: false },
    ],
    rows: [
      {
        name: "Florida",
        position: "1185 Doss Ave, Orlando, FL 32809",
        age: <i className="fas fa-xmark text-primary"></i>,
      },
      {
        name: "San Jose",
        position: "1737 N. Ist St., Suite 230, San Jose, CA 95112",
        age: <i className="fas fa-xmark text-primary"></i>,
      },

      {
        name: "Texas",
        position: "11327 Reeder Rd STE 200, Dallas, TX 75229",
        office: " ",
        age: <i className="fas fa-xmark text-primary"></i>,
      },
    ],
  };
  return (
    <React.Fragment>
      <>
        <MainLinks active={1} />
        <Body
          tablinks={1}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">

                  <div className="mt-5">

                    <table className="table datatable mt-0 border tableTree">
                      <tbody>
                        <tr>
                          <th>1</th>
                          <th>First</th>
                          <th>Last</th>
                          <th>Mark</th>
                          <th>Otto</th>
                          <th>Mark</th>
                          <th>Otto</th>
                          <th>@mdo</th>
                        </tr>
                        <tr>
                          <td>1</td>
                          <td>First</td>
                          <td>Last</td>
                          <td>Mark</td>
                          <td>Otto</td>
                          <td>Mark</td>
                          <td>Otto</td>
                          <td>@mdo</td>
                        </tr>
                        <tr>
                          <td colspan="8" className="nestedDiv">
                            <table className="datatable mt-0 border table2 w-100">
                              <tr className="table2 w-100">
                                <td>1</td>
                                <td>First</td>
                                <td>Last</td>
                                <td>Mark</td>
                                <td>Otto</td>
                                <td>Mark</td>
                                <td>Otto</td>
                                <td>@mdo</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div id="popuppage">
                    <MDBBtn className="m-2" onClick={toggleModal1}>
                      {t("unassignDevice")}
                    </MDBBtn>
                    <MDBModal open={modal1} setShow={setModal1} tabIndex="-1">
                      <MDBModalDialog>
                        <MDBModalContent className="popup-width">
                          <MDBModalHeader>
                            <MDBModalTitle className="modal-title">
                              {t("unassignDevice")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleModal1}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            Unassign Poly VVX 601 0004F21F3434 for Nick
                            Leyendeck IP Phone 1
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn
                              color="secondary"
                              className="cancle-btn"
                              onClick={toggleModal1}
                            >
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleModal2}>
                      {t("addDevice")}
                    </MDBBtn>
                    <MDBModal open={modal2} setShow={setModal2} tabIndex="-1">
                      <MDBModalDialog>
                        <MDBModalContent className="popup-width">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              <strong>{t("addDevice")}</strong>
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleModal2}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("friendlyName")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Nick T48S"
                                />
                              </div>
                              <div className="routing-check">
                                <input
                                  type="checkbox"
                                  className="routing-checks m-1"
                                />
                                {t("UseassignedUserName")}
                              </div>
                              <div className="tel-numbers pt-2">
                                <strong>{t("switchUser")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Nick Leyendecker"
                                />
                              </div>
                              <div className="tel-numbers pt-3">
                                <strong>{t("friendlyName")}</strong>
                              </div>

                              <MDBDatatable
                                multi sortField="Designation" 
                                selectable
                                pagination={false}
                                data={basicData}
                              />
                              <div className="tel-numbers pt-3">
                                <strong>{t("selectProvisioningType")}</strong>
                              </div>
                              <div className="phrecording me-5 mb-2">
                                {t("selectProvisioningTypetxt")}
                              </div>

                              <MDBSelect
                                classID="w-25"
                                data={[
                                  { text: "Auto", value: 1 },
                                  { text: "Two", value: 2 },
                                  { text: "Three", value: 3 },
                                  { text: "Four", value: 4 },
                                ]}
                              />

                              <div className="tel-numbers pt-2 mb-2">
                                <strong>{t("newDevicetxt")}</strong>
                              </div>
                              <MDBSelect
                                classID="w-25"
                                data={[
                                  { text: "New", value: 1 },
                                  { text: "Two", value: 2 },
                                  { text: "Three", value: 3 },
                                  { text: "Four", value: 4 },
                                ]}
                              />

                              <div className="tel-numbers mt-2">
                                <strong>{t("model")}</strong>
                              </div>
                              <div className="form mt-1 mb-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Poly VVX 601"
                                />
                              </div>

                              <div className="tel-numbers">
                                <strong>{t("MACaddress")}</strong>
                              </div>
                              <div className="form mt-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="0004F21F3434"
                                />
                              </div>

                              <div className="tel-numbers pt-2">
                                <strong>{t("select911loc")}</strong>
                              </div>
                              <div className="phrecording me-1 mb-2 w-100">
                                {t("select911loctxt")}
                              </div>
                              <div className="search-btn">
                                <MDBSelect
                                  className="w-100"
                                  data={[
                                    { text: "One" },
                                    { text: "Two" },
                                    { text: "Three" },
                                    { text: "Four" },
                                    { text: "Five" },
                                    { text: "Six" },
                                    { text: "Seven" },
                                    { text: "Eight" },
                                  ]}
                                  clearBtn
                                />
                                <div className="form-add">
                                  <button
                                    type="button"
                                    className="btn green-button-add  rip ple-surface"
                                    data-mdb-toggle="modal"
                                    data-mdb-target="#exampleModal"
                                  >
                                    <MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn
                              color="secondary"
                              className="cancle-btn"
                              onClick={toggleModal2}
                            >
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    {/* Launch DLF Model  */}

                    <MDBBtn className="m-2" onClick={toggleShow}>
                      {t("BLFGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={blfGroupModal}
                      setShow={setBlfGroupModal}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("BLFGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <p>{t("BLFerrortxt")}</p>
                            <p className="pt-2">{t("BLFerrortxt1")}</p>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    {/* Launch DLF Model  */}

                    <MDBBtn className="m-2" onClick={toggleShow7}>
                      {t("replaceDevice")}
                    </MDBBtn>
                    <MDBModal
                      open={replaceDevice}
                      setShow={setReplaceDevice}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("replaceDevice")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow7}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            {t("replace")} Nick Leyendecker IP Phone 1
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow7}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    {/* Launch DLF Model  */}
                    <h4 className="mt-4">Locations PopOvers</h4>
                    {/* Start of Location Pop1 */}

                    <MDBPopover
                      color="primary"
                      btnChildren="Multi Device Location with a 911 Location"
                      placement="top"
                      style={{ width: "25%", marginTop: "25px" }}
                    >
                      <MDBPopoverHeader className="p-3">
                        <div className="d-flex justify-content-start">
                          <img src={Location} className="emergencyModal-logo" />
                          <div className="px-3 modal-title w-100">
                            {t("emergency911Location")}
                            <button
                              className="ripple ripple-surface ripple-surface-light btn-close float-end"
                              role="button"
                            ></button>
                            <div className="tel-numbers-small">Nick's Home</div>
                            <div className="tel-numbers-small">
                              2252 Haviland Drive, Grants Pass 97527
                            </div>
                          </div>
                        </div>
                      </MDBPopoverHeader>

                      <MDBPopoverBody>
                        <MDBTable align="middle">
                          <MDBTableHead>
                            <tr>
                              <th scope="col">{t("name")}</th>
                              <th scope="col">{t("Model")}</th>
                              <th scope="col">{t("MAC")}</th>
                              <th scope="col">{t("IPAddress")}</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={phoneImageActive} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      Nick VVX601
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">Poly VVX 601</p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>0004F21F3434</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={PhoneBlue} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      Nick VVX601
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">Poly VVX 601</p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>0004F21F3434</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={LaptopOrange} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      Nick VVX601
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">Poly VVX 601</p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>0004F21F3434</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                          </MDBTableBody>
                        </MDBTable>
                      </MDBPopoverBody>
                    </MDBPopover>

                    {/* End of Location Pop1 */}

                    {/* Start  of Location Pop2 */}
                    <MDBPopover
                      color="primary"
                      btnChildren="Multi Device Location WITHOUT a 911 Location"
                      placement="top"
                      style={{ width: "25%", marginTop: "25px" }}
                    >
                      <MDBPopoverHeader className="p-3">
                        <div
                          className="d-flex justify-content-start"
                          emergencyModal
                        >
                          <img src={Location} className="-logo" />
                          <div className="px-3 modal-title w-100">
                            {t("emergency911Location")}
                            <button
                              className="ripple ripple-surface ripple-surface-light btn-close float-end"
                              role="button"
                            ></button>
                          </div>
                        </div>
                      </MDBPopoverHeader>

                      <MDBPopoverBody>
                        <MDBTable align="middle">
                          <MDBTableHead>
                            <tr>
                              <th scope="col">{t("name")}</th>
                              <th scope="col">{t("Model")}</th>
                              <th scope="col">{t("MAC")}</th>
                              <th scope="col">{t("IPAddress")}</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={PhoneBlue} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      Nick Leyendecker
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">
                                  {JSON.parse(sessionStorage.getItem("admin_session")).streams_productname} {t("iOS")}
                                </p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>-</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={LaptopOrange} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      NNick Leyendecker
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">
                                  {JSON.parse(sessionStorage.getItem("admin_session")).streams_productname} {t("windows")}
                                </p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>-</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                          </MDBTableBody>
                        </MDBTable>
                      </MDBPopoverBody>
                    </MDBPopover>
                    {/* End  of Location Pop2 */}

                    {/* Start of Location Pop3 */}

                    <MDBPopover
                      color="primary"
                      btnChildren="Single Device Location with a 911 Location"
                      placement="top"
                      style={{ width: "25%", marginTop: "25px" }}
                    >
                      <MDBPopoverHeader className="p-3">
                        <div className="d-flex justify-content-start">
                          <img
                            src={phoneImageActive}
                            className="emergencyModal-logo"
                          />
                          <div className="px-3 modal-title w-100">
                            {t("emergency911Location")}
                            <button
                              className="ripple ripple-surface ripple-surface-light btn-close float-end"
                              role="button"
                            ></button>
                            <div className="tel-numbers-small">Nick's Home</div>
                            <div className="tel-numbers-small">
                              2252 Haviland Drive, Grants Pass 97527
                            </div>
                          </div>
                        </div>
                      </MDBPopoverHeader>

                      <MDBPopoverBody>
                        <MDBTable align="middle">
                          <MDBTableHead>
                            <tr>
                              <th scope="col">{t("name")}</th>
                              <th scope="col">{t("Model")}</th>
                              <th scope="col">{t("MAC")}</th>
                              <th scope="col">{t("IPAddress")}</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={phoneImageActive} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      Nick VVX601
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">Poly VVX 601</p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>0004F21F3434</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                          </MDBTableBody>
                        </MDBTable>
                      </MDBPopoverBody>
                    </MDBPopover>

                    {/* End of Location Pop3 */}

                    {/* Start of Location Pop1 */}

                    <MDBPopover
                      color="primary"
                      btnChildren="Popover on top"
                      placement="top"
                      style={{ width: "25%", marginTop: "25px" }}
                    >
                      <MDBPopoverHeader className="p-3">
                        <div className="d-flex justify-content-start">
                          <img
                            src={PhoneBlue}
                            className="emergencyModal-logo"
                          />
                          <div className="px-3 modal-title w-100">
                            {t("emergency911Location")}
                            <button
                              className="ripple ripple-surface ripple-surface-light btn-close float-end"
                              role="button"
                            ></button>
                            <div className="tel-numbers-small">Nick's Home</div>
                            <div className="tel-numbers-small">
                              2252 Haviland Drive, Grants Pass 97527
                            </div>
                          </div>
                        </div>
                      </MDBPopoverHeader>

                      <MDBPopoverBody>
                        <MDBTable align="middle">
                          <MDBTableHead>
                            <tr>
                              <th scope="col">{t("name")}</th>
                              <th scope="col">{t("Model")}</th>
                              <th scope="col">{t("MAC")}</th>
                              <th scope="col">{t("IPAddress")}</th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            <tr>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img src={PhoneBlue} />
                                  <div className="ms-3">
                                    <p className="fw-normal mb-1">
                                      Nick Leyendecker
                                    </p>
                                    {/* <p className='text-muted mb-0'>john.doe@gmail.com</p> */}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="fw-normal mb-1">
                                  {JSON.parse(sessionStorage.getItem("admin_session")).streams_productname} {t("iOS")}
                                </p>
                                {/* <p className='text-muted mb-0'>IT department</p> */}
                              </td>
                              <td>0004F21F3434</td>
                              <td>
                                <p className="fw-normal mb-1">
                                  64.68.252.189:51923
                                </p>
                              </td>
                            </tr>
                          </MDBTableBody>
                        </MDBTable>
                      </MDBPopoverBody>
                    </MDBPopover>

                    {/* End of Location Pop1 */}

                    <h4 className="mt-4">{t("AddorRmPagingGroup")}</h4>

                    <MDBBtn className="m-2" onClick={toggleShow2}>

                      {t("AddPagingGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={pagingGroupModal}
                      setShow={setPagingGroupModal}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddPagingGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow2}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="tel-numbers">
                              <strong>{t("PagingGroupName")}</strong>
                            </div>
                            <div className="form pt-1">
                              <input
                                type="text"
                                className="form-control"
                                value="Backoffice"
                              />
                            </div>

                            <div className="tel-numbers pt-2">
                              <strong>{t("GroupID")}</strong>
                            </div>
                            <div className="form pt-1">
                              <input
                                type="text"
                                className="form-control"
                                value="4"
                              />
                            </div>
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow2}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow3}>
                      {t("RmPagebtn")}
                    </MDBBtn>
                    <MDBModal
                      open={removePageModal}
                      setShow={setRemovePageModal}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("RmPagingGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow3}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            {t("RmPagingGroupBackoffice")}
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow3}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h3 className="mt-4">{t("RemovePage")}</h3>
                    <MDBBtn className="m-2" onClick={toggleShow4}>
                      {t("RmPagebtn")}
                    </MDBBtn>
                    <MDBModal
                      open={removeDevice}
                      setShow={setRemoveDevice}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("RemoveDevice")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow4}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            {t("remove")} Poly WX 601 0004F21F3434
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow4}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="mt-4">{t("addRmvBLFGroup")}</h4>

                    <MDBBtn className="m-2" onClick={toggleShow5}>
                      {t("addBLFGroup")}
                    </MDBBtn>
                    <MDBModal open={addBLF} setShow={setAddBLF} tabIndex="-1">
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addBLFGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow5}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>{t("addBLFGrouptxt")}</MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow5}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow6}>
                      {t("updateBLFGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={removeBLF}
                      setShow={setRemoveBLF}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("updateBLFGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow6}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>{t("updateBLFGrouptxt")}</MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow6}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>


                    <MDBBtn className="m-2" onClick={ToggleRemoveBLF}>
                      {t("rmvBLFGroup")}
                    </MDBBtn>

                    <MDBModal
                      open={RemoveBLFGroup}
                      setShow={setRemoveBLFGroup}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("rmvBLFGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={ToggleRemoveBLF}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>{t("rmvBLFGrouptxt")}</MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={ToggleRemoveBLF}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("setSchedule")}</h4>

                    <MDBBtn className="m-2" onClick={toggleShow8}>
                      {t("setSchedulefor")} Nick Leyendecker
                    </MDBBtn>
                    <MDBModal
                      open={Schedule}
                      setShow={setSchedule}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("setSchedulefor")} Nick Leyendecker
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow8}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="row">
                              <div className="w-30 px-2">
                                <div className="pt-0">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("sunday")}
                                </div>

                                <div className="pt-3">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("monday")}
                                </div>

                                <div className="pt-3">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("tuesday")}
                                </div>

                                <div className="pt-3">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("wednesday")}
                                </div>

                                <div className="pt-3">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("thursday")}
                                </div>

                                <div className="pt-3">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("friday")}
                                </div>

                                <div className="pt-3">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                  {t("saturday")}
                                </div>
                              </div>

                              <div className="w-65 pl-0 pr-1">
                                <div className="w-100 pt-0 invisible d-flex">
                                  <label className="px-2 pt-2">
                                    {t("from")}
                                  </label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                    ]}
                                  />
                                  <label className="px-2 pt-2">{t("to")}</label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                    ]}
                                  />
                                </div>

                                <div className="w-100 pt-3 d-flex">
                                  <label className="px-2 pt-2">
                                    {t("from")}
                                  </label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                    ]}
                                  />
                                  <label className="px-2 pt-2">{t("to")}</label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                    ]}
                                  />
                                </div>

                                <div className="w-100 pt-3 d-flex">
                                  <label className="px-2 pt-2">
                                    {t("from")}
                                  </label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                    ]}
                                  />
                                  <label className="px-2 pt-2">{t("to")}</label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                    ]}
                                  />
                                </div>

                                <div className="w-100 pt-3 d-flex">
                                  <label className="px-2 pt-2">
                                    {t("from")}
                                  </label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                    ]}
                                  />
                                  <label className="px-2 pt-2">{t("to")}</label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                    ]}
                                  />
                                </div>

                                <div className="w-100 pt-3 d-flex">
                                  <label className="px-2 pt-2">
                                    {t("from")}
                                  </label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                    ]}
                                  />
                                  <label className="px-2 pt-2">{t("to")}</label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                    ]}
                                  />
                                </div>
                                <div className="w-100 pt-3 d-flex">
                                  <label className="px-2 pt-2">
                                    {t("from")}
                                  </label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                      { text: "9:00 AM", value: 1 },
                                    ]}
                                  />
                                  <label className="px-2 pt-2">{t("to")}</label>
                                  <MDBSelect
                                    className="w-90"
                                    data={[
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                      { text: "6:00 PM", value: 1 },
                                    ]}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="tel-numbers mt-2">
                              <strong>Time Zone</strong>
                            </div>
                            <MDBSelect
                              data={[
                                {
                                  text: "(GMT-08-00) Pacific Time (AmaricalLak Angeles)",
                                  value: 1,
                                },
                                { text: "Two", value: 2 },
                                { text: "Three", value: 3 },
                                { text: "Four", value: 4 },
                                { text: "Five", value: 5 },
                                { text: "Six", value: 6 },
                                { text: "Seven", value: 7 },
                                { text: "Eight", value: 8 },
                              ]}
                            />
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow8}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("ACDQueue")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow9}>
                      {t("add_ACDQueue")}
                    </MDBBtn>
                    <MDBModal
                      open={AddACDQueue}
                      setShow={setAddACDQueue}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("add_ACDQueue")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow9}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("ACDQueueName")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="SupportACD"
                                />
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("extension")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="5805"
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow9}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">Hunt Groups</h4>
                    <MDBBtn className="m-2" onClick={toggleShow10}>
                      <MDBIcon fas icon="plus" size="sm" /> {t("addHuntGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={AddHuntGroup}
                      setShow={setAddHuntGroup}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addHuntGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow10}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("HuntGroupName")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Sales"
                                />
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("extension")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="5575 "
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow10}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow15}>
                      {t("HGanouncementGreeting")}
                    </MDBBtn>
                    <MDBModal
                      open={HuntGrouppreAnouncement}
                      setShow={setHuntGrouppreAnouncement}
                      tabIndex="-1"
                    >
                      <MDBModalDialog className="modal-dialogw">
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("HGanouncementGreeting")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow15}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="add-numbermain pe-2 py-2">
                              <div>
                                <div className="tel-numbers">
                                  {t("GreetingType")}
                                </div>
                                <span className="phrecording">
                                  {t("DefaultPersonalizedGreeting")}
                                </span>
                              </div>
                              <div>
                                <MDBSelect
                                  data={[
                                    { text: "Personalized", value: 1 },
                                    { text: "Two", value: 2 },
                                    { text: "Three", value: 3 },
                                    { text: "Four", value: 4 },
                                    { text: "Five", value: 5 },
                                    { text: "Six", value: 6 },
                                    { text: "Seven", value: 7 },
                                    { text: "Eight", value: 8 },
                                  ]}
                                />
                              </div>
                            </div>
                            <div className="routing-border"></div>
                            <div>
                              <MDBTabs className="mt-3 mb-3">
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab1")}
                                    active={basicActive === "tab1"}
                                    className="nav-link"
                                  >
                                    {t("mediaLibrary")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab2")}
                                    active={basicActive === "tab2"}
                                    className="nav-link"
                                  >
                                    {t("upload")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab3")}
                                    active={basicActive === "tab3"}
                                    className="nav-link"
                                  >
                                    {t("recordWithPC")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab4")}
                                    active={basicActive === "tab4"}
                                    className="nav-link"
                                  >
                                    {t("recordViaPhone")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                              </MDBTabs>

                              <MDBTabsContent>
                                <MDBTabsPane open={basicActive === "tab1"}>
                                  <div>
                                    <MDBSelect
                                      data={[
                                        {
                                          text: "Open this select menu",
                                          value: 1,
                                        },
                                        { text: "Two", value: 2 },
                                        { text: "Three", value: 3 },
                                        { text: "Four", value: 4 },
                                        { text: "Five", value: 5 },
                                        { text: "Six", value: 6 },
                                        { text: "Seven", value: 7 },
                                        { text: "Eight", value: 8 },
                                      ]}
                                    />
                                  </div>
                                </MDBTabsPane>
                                <MDBTabsPane open={basicActive === "tab2"}>
                                  {/* Tab 2 content */}
                                  <div>
                                    <div>{t("name")}</div>
                                    <div className="my-3">
                                      <MDBInput
                                        label="Enter a Name"
                                        id="form1"
                                        type="text"
                                      />
                                    </div>
                                    <div>
                                      <MDBFile label="" id="customFile" />
                                      <span className="phrecording">
                                        {t("maxuploadsize")}
                                      </span>
                                    </div>

                                    <p className="text-danger my-2">
                                      {t("uploadtxt")}
                                    </p>
                                    <div className="audio-controls-hunt py-2 d-flex align-items-center">
                                      <audio src="#" controls></audio>
                                      {/* <div className="Record ms-3"></div> */}
                                      <MDBBtn className="ms-3">
                                        {t("upload")}
                                      </MDBBtn>
                                    </div>
                                  </div>
                                </MDBTabsPane>
                                <MDBTabsPane open={basicActive === "tab3"}>
                                  {/* Tab 3 content */}
                                  <div className="audio-controls py-3">
                                    <audio src="#" controls></audio>
                                    <div className="Record ms-3"></div>
                                    <MDBBtn className="ms-3">
                                      {t("upload")}
                                    </MDBBtn>
                                  </div>
                                </MDBTabsPane>

                                <MDBTabsPane open={basicActive === "tab4"}>
                                  {/* Tab 3 content */}
                                  <div>
                                    <div>{t("wheretoCall")}</div>
                                    <div className="mt-1 d-flex">
                                      <div className="align-items-center">
                                        <MDBInput
                                          label="name@example.com"
                                          id="form1"
                                          type="text"
                                        />
                                        <div>
                                          <MDBBtn className="ms-3">
                                            {t("call")}
                                          </MDBBtn>
                                        </div>
                                      </div>
                                      {/* <div>Connected</div> */}
                                      <div></div>
                                    </div>
                                    <div>{t("connected")}</div>
                                    <div className="d-flex align-items-center">
                                      <div className="text-danger">
                                        {t("connectedtxt")}
                                      </div>
                                      <div>
                                        <MDBBtn
                                          className="me-3 mx-3"
                                          color="danger"
                                        >
                                          {t("endCall")}
                                        </MDBBtn>
                                      </div>
                                    </div>
                                  </div>
                                </MDBTabsPane>
                              </MDBTabsContent>
                            </div>
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow15}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("AutoAttendant")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow11}>
                      {t("addAutoAttendant")}
                    </MDBBtn>
                    <MDBModal
                      open={AddAutoAttendant}
                      setShow={setAddAutoAttendant}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("addAutoAttendant")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow11}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("autoAttendantName")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Main Open AA"
                                />
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("extension")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="5000"
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow11}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow14}>
                      {t("VoiceMailunavaliableGreeting")}
                    </MDBBtn>
                    <MDBModal
                      open={VoiceMail}
                      setShow={setVoiceMail}
                      tabIndex="-1"
                    >
                      <MDBModalDialog className="modal-dialogw">
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("VoiceMailunavaliableGreeting")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow14}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="add-numbermain px-2">
                              <div>
                                <div className="tel-numbers">
                                  {t("GreetingType")}
                                </div>
                                <span className="phrecording">
                                  {t("DefaultPersonalizedGreeting")}
                                </span>
                              </div>
                              <div>
                                <MDBSelect
                                  className="w-100"
                                  data={[
                                    { text: "Personalized", value: 1 },
                                    { text: "Two", value: 2 },
                                    { text: "Three", value: 3 },
                                    { text: "Four", value: 4 },
                                    { text: "Five", value: 5 },
                                    { text: "Six", value: 6 },
                                    { text: "Seven", value: 7 },
                                    { text: "Eight", value: 8 },
                                  ]}
                                />
                              </div>
                            </div>
                            <div className="routing-border"></div>
                            <div>
                              <MDBTabs className="mb-3">
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab1")}
                                    active={basicActive === "tab1"}
                                    className="nav-link"
                                  >
                                    {t("upload")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab2")}
                                    active={basicActive === "tab2"}
                                    className="nav-link"
                                  >
                                    {t("recordonMic")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                                <MDBTabsItem>
                                  <MDBTabsLink
                                    onClick={() => handleBasicClick("tab3")}
                                    active={basicActive === "tab3"}
                                    className="nav-link"
                                  >
                                    {t("recordonPhone")}
                                  </MDBTabsLink>
                                </MDBTabsItem>
                              </MDBTabs>

                              <MDBTabsContent>
                                <MDBTabsPane open={basicActive === "tab1"}>
                                  <div>
                                    <MDBFile
                                      label="Default file input example"
                                      id="customFile"
                                    />
                                    <span className="phrecording">
                                      {t("maxuploadsize")}
                                    </span>
                                  </div>
                                </MDBTabsPane>
                                <MDBTabsPane open={basicActive === "tab2"}>
                                  {/* Tab 2 content */}
                                  <div>
                                    <div className="audio-controls py-3">
                                      <audio src="#" controls></audio>
                                      <div className="Record ms-3"></div>
                                      <MDBBtn className="ms-3">
                                        {t("upload")}
                                      </MDBBtn>
                                    </div>
                                  </div>
                                </MDBTabsPane>
                                <MDBTabsPane open={basicActive === "tab3"}>
                                  {/* Tab 3 content */}
                                  <div>
                                    <div>{t("wheretoCall")}</div>
                                    <div className="mt-0 d-flex">
                                      <div className="d-flex align-items-center">
                                        <MDBInput
                                          label="name@example.com"
                                          id="form1"
                                          type="text"
                                        />
                                        <div>
                                          <MDBBtn className="ms-3">
                                            {t("call")}
                                          </MDBBtn>
                                        </div>
                                      </div>
                                      {/* <div>Connected</div> */}
                                      <div></div>
                                    </div>
                                  </div>
                                </MDBTabsPane>
                              </MDBTabsContent>
                            </div>
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow14}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("add_Numbers")}</h4>

                    <MDBBtn className="m-2" onClick={toggleShow12}>
                      <MDBIcon fas icon="plus" size="sm" />  {t("add_Numbers")}
                    </MDBBtn>
                    <MDBModal
                      open={AddNumbers}
                      setShow={setAddNumbers}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("add_ACDQueue")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow12}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div>
                                <div className="form-group row">
                                  <div className="col-12">
                                    <div className="form-outlines">
                                      <MDBChipsInput
                                        label="Example label"
                                        editable
                                        initialValues={[
                                          { tag: "661863 8829" },
                                          { tag: "661863 8829" },
                                          { tag: "MDBVue" },
                                        ]}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <label className="selectall pt-2">
                                {t("selectAll")}
                              </label>
                              <div>
                                <div className="routing-numbers">
                                  <div className="numberadd-green">
                                    661863 8829
                                  </div>
                                  <div className="numberadd-green">
                                    661863 8829
                                  </div>
                                  <div className="numberadd">661863 8829</div>
                                  <div className="numberadd">661863 8829</div>
                                  <div className="numberadd">661863 8829</div>
                                </div>
                                <div className="routing-numbers">
                                  <div className="numberadd">661863 8829</div>
                                  <div className="numberadd">661863 8829</div>
                                  <div className="numberadd">661863 8829</div>
                                  <div className="numberadd">661863 8829</div>
                                  <div className="numberadd">661863 8829</div>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow12}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow13}>
                      <MDBIcon fas icon="plus" size="sm" />  {t('addusers')}
                    </MDBBtn>
                    <MDBModal
                      open={AddUsers}
                      setShow={setAddUsers}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t('addusers')}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow13}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <MDBSelect
                              data={[
                                { text: "One", value: 1 },
                                { text: "Two", value: 2 },
                                { text: "Three", value: 3 },
                                { text: "Four", value: 4 },
                                { text: "Five", value: 5 },
                                { text: "Six", value: 6 },
                                { text: "Seven", value: 7 },
                                { text: "Eight", value: 8 },
                              ]}
                            />
                            <div>
                              <div className="pt-3">
                                <div className="form-group row">
                                  <div className="col-12">
                                    <div className="form-outlines w-100">
                                      <MDBChipsInput
                                        label="Example label"
                                        editable
                                        initialValues={[
                                          { tag: "Jerome Fiiesenhn" },
                                          { tag: "Jon Oest" },
                                        ]}
                                      />
                                    </div>
                                    <label className="my-3">
                                      {t("selectAll")}
                                    </label>
                                    <MDBTable align="middle">
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col">{t("name")}</th>
                                          <th scope="col">{t("extension")}</th>
                                          <th scope="col">{t("location")}</th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <img
                                                src="https://mdbootstrap.com/img/new/avatars/8.jpg"
                                                alt=""
                                                style={{
                                                  width: "45px",
                                                  height: "45px",
                                                }}
                                                className="rounded-circle"
                                              />
                                              <div className="ms-3">
                                                <p className="fw-normal mb-1">
                                                  {t("agentname")}
                                                </p>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <p className="fw-normal mb-1">
                                              {t("extensionnumber")}
                                            </p>
                                          </td>
                                          <td>
                                            <p className="fw-normal mb-1">
                                              {t("agentlocation")}
                                            </p>
                                          </td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow13}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow16}>
                      {t("AddSupervisors")}
                    </MDBBtn>
                    <MDBModal
                      open={AddSupervisors}
                      setShow={setAddSupervisors}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddSupervisors")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow16}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <MDBSelect
                              data={[
                                { text: "One", value: 1 },
                                { text: "Two", value: 2 },
                                { text: "Three", value: 3 },
                                { text: "Four", value: 4 },
                                { text: "Five", value: 5 },
                                { text: "Six", value: 6 },
                                { text: "Seven", value: 7 },
                                { text: "Eight", value: 8 },
                              ]}
                            />
                            <div className="pt-3">
                              <div className="form-group row">
                                <div className="col-12">
                                  <div className=" form-outlines">
                                    <MDBChipsInput
                                      label="Example label"
                                      editable
                                      initialValues={[
                                        { tag: "Jerome Fiiesenhn" },
                                        { tag: "Jon Oest" },
                                      ]}
                                    />
                                  </div>
                                  <label className="mt-3">
                                    {t("selectAll")}
                                  </label>
                                  <MDBTable align="middle">
                                    <MDBTableHead>
                                      <tr>
                                        <th scope="col">{t("name")}</th>
                                        <th scope="col">{t("extension")}</th>
                                        <th scope="col">{t("location")}</th>
                                      </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <img
                                              src="https://mdbootstrap.com/img/new/avatars/8.jpg"
                                              alt=""
                                              style={{
                                                width: "45px",
                                                height: "45px",
                                              }}
                                              className="rounded-circle"
                                            />
                                            <div className="ms-3">
                                              <p className="fw-normal mb-1">
                                                {t("agentname")}
                                              </p>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <p className="fw-normal mb-1">
                                            {t("extensionnumber")}
                                          </p>
                                        </td>
                                        <td>
                                          <p className="fw-normal mb-1">
                                            {t("agentlocation")}
                                          </p>
                                        </td>
                                      </tr>
                                    </MDBTableBody>
                                  </MDBTable>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow16}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow17}>
                      {t("AddAgents")}
                    </MDBBtn>
                    <MDBModal
                      open={AddAgents}
                      setShow={setAddAgents}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddAgents")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow17}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <MDBSelect
                              data={[
                                { text: "One", value: 1 },
                                { text: "Two", value: 2 },
                                { text: "Three", value: 3 },
                                { text: "Four", value: 4 },
                                { text: "Five", value: 5 },
                                { text: "Six", value: 6 },
                                { text: "Seven", value: 7 },
                                { text: "Eight", value: 8 },
                              ]}
                            />
                            <div>
                              <div className="pt-3">
                                <div className="form-group row">
                                  <div className="col-12">
                                    <div className="form-outlines w-100">
                                      <MDBChipsInput
                                        label="Example label"
                                        editable
                                        initialValues={[
                                          { tag: "Jerome Fiiesenhn" },
                                          { tag: "Jon Oest" },
                                        ]}
                                      />
                                    </div>

                                    <label className="my-3">
                                      {t("selectAll")}
                                    </label>
                                    <MDBTable align="middle">
                                      <MDBTableHead>
                                        <tr>
                                          <th scope="col">{t("name")}</th>
                                          <th scope="col">{t("extension")}</th>
                                          <th scope="col">{t("location")}</th>
                                        </tr>
                                      </MDBTableHead>
                                      <MDBTableBody>
                                        <tr>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <img
                                                src="https://mdbootstrap.com/img/new/avatars/8.jpg"
                                                alt=""
                                                style={{
                                                  width: "45px",
                                                  height: "45px",
                                                }}
                                                className="rounded-circle"
                                              />
                                              <div className="ms-3">
                                                <p className="fw-normal mb-1">
                                                  {t("agentname")}
                                                </p>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <p className="fw-normal mb-1">
                                              {t("extensionnumber")}
                                            </p>
                                          </td>
                                          <td>
                                            <p className="fw-normal mb-1">
                                              {t("agentlocation")}
                                            </p>
                                          </td>
                                        </tr>
                                      </MDBTableBody>
                                    </MDBTable>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow17}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("addHoliday")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow18}>
                      {t("addHoliday")}
                    </MDBBtn>
                    <MDBModal
                      open={AddHoliday}
                      setShow={setAddHoliday}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addHoliday")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow18}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="4th of July"
                                />
                              </div>
                              <div className='d-flex justify-content-between'>
                                <div className="tel-numbers mt-2 w-50">
                                  <strong>From</strong>
                                  <div className="form pt-1 w-100">
                                    <MDBDatepicker inline />
                                  </div>
                                </div>
                                <div className="tel-numbers mt-2">
                                  <strong className="ms-2">To</strong>
                                  <div className="form pt-1 w-100 ps-2">
                                    <MDBDatepicker inline />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow18}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("billingGroup")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow19}>
                      {t("billingGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={BillingGroup}
                      setShow={setBillingGroup}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("billingGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow19}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="tel-numbers">
                              <strong>{t("billingGroup")}</strong>
                            </div>
                            <div className="form pt-1">
                              <select
                                className="form-select form-control"
                                name="San Jose"
                              >
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>

                              <div className="mt-2">
                                <MDBCheckbox
                                  name="inlineCheck"
                                  id="inlineCheckbox1"
                                  value="option1"
                                  label="Invoice this location"
                                  inline
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow19}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("QuoteAccountBilling")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow20}>
                      {t("addUser")}
                    </MDBBtn>
                    <MDBModal open={Adduser} setShow={setAdduser} tabIndex="-1">
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addUser")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow20}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="row">
                              <div className="col-6">
                                <div className="tel-numbers">
                                  <strong>{t("firstName")}</strong>
                                </div>
                                <div className="form pt-1 w-100">
                                  <input
                                    type="text"
                                    value="Jerome"
                                    className="w-100"
                                  />
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="tel-numbers">
                                  <strong>{t("lastName")}</strong>
                                </div>
                                <div className="form pt-1">
                                  <input
                                    type="text"
                                    value="Friesenhahn"
                                    className="w-100"
                                  />
                                </div>
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("email_address")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="jerome@panterranetworks.com"
                                />
                              </div>
                              <div className="col-6 pt-2">
                                <div className="tel-numbers">
                                  <strong>{t("SeatPlan")}</strong>
                                </div>
                                <div className="form pt-1">
                                  <select
                                    className="form-select form-control w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-6 pt-2">
                                <div className="tel-numbers">
                                  <strong>{t("SeatTeam")}</strong>
                                </div>
                                <div className="form pt-1">
                                  <select
                                    className="form-select form-control w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("extension")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="2241"
                                />
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("location")}</strong>
                              </div>
                              <div className="form pt-1">
                                <select
                                  className="form-select form-control w-100"
                                  name="San Jose"
                                >
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>

                              <div className="tel-numbers mt-2">
                                <strong>{t("billingGroup")}</strong>
                              </div>
                              <div className="form pt-1">
                                <select
                                  className="form-select form-control w-100"
                                  name="San Jose"
                                >
                                  <option value="San Jose">
                                    Inherit from Location
                                  </option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <p className="text-secondary pt-2">
                                A
                                <span className="green-text">

                                  {t("CallCenter")}
                                </span>
                                {t("CallCenterseattxt")}.
                              </p>
                              <p className="text-secondary lh-sm">
                                {t("AddOnenabletxt")}
                                <span className="green-text"> $44.95</span>
                              </p>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow20}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("addlocation")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow21}>
                      <MDBIcon fas icon="plus" size="sm" />  {t("addlocation")} 24/7
                    </MDBBtn>
                    <MDBModal
                      open={AddLocation}
                      setShow={setAddLocation}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addlocation")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow21}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("StreetAddress")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  placeholder="Suite, unit, building..."
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("City")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Grants Pass"
                                />
                              </div>
                              <div className="row pt-3">
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    <strong>{t("State")}</strong>
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Oregon"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    <strong>{t("ZIPCode")}</strong>
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="95727"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="tel-numbers mt-3">
                                <strong>{t("PrimaryContact")}</strong>
                              </div>
                              <div className="row pt-2">
                                <div className="col-6 fw-500">
                                  <div className="tel-numbers">
                                    {t("firstName")}
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Jerome"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                                <div className="col-6 fw-500">
                                  <div className="tel-numbers">
                                    {t("lastName")}
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Friesenhahn"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("email")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Jerome@panterranetworks.com "
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="541 856 9547"
                                />
                              </div>
                              <div className="routing-border my-2"> </div>

                              <div className="tel-numbers mt-1">
                                <strong>{t("911Information")}</strong>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("en911services")}
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("UsePrimaryCont")}
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="tel-numbers mt-2">
                                {t("UsePrimaryCont")}
                              </div>
                              <MDBSelect
                                className=" mt-2"
                                data={[
                                  { text: "One", value: 1 },
                                  { text: "Two", value: 2 },
                                  { text: "Three", value: 3 },
                                  { text: "Four", value: 4 },
                                  { text: "Five", value: 5 },
                                  { text: "Six", value: 6 },
                                  { text: "Seven", value: 7 },
                                  { text: "Eight", value: 8 },
                                ]}
                              />
                              <div className="tel-numbers mt-2">
                                {t("Speclocation")}
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  placeholder="Frontdesk, Server Room, etc.."
                                />
                              </div>
                              <div className="routing-border my-2"></div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("weeklyschedule")}</strong>
                              </div>
                              <div className="mb-2">
                                <MDBRadio
                                  name="inlineRadio"
                                  id="inlineRadio1"
                                  value="option1"
                                  label="24/7"
                                  inline
                                />
                                <MDBRadio
                                  name="inlineRadio"
                                  id="inlineRadio2"
                                  value="option2"
                                  label="Weekly Schedule"
                                  inline
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("billingGroup")}</strong>
                              </div>
                              <div className="form mt-1 d-inline-flex w-100 align-items-center justify-content-between">
                                <div className="w-50">
                                  <select
                                    className="form-select form-control w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">
                                      Prestige Worldwide
                                    </option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                                <div>
                                  <MDBCheckbox
                                    name="inlineCheck"
                                    id="inlineCheckbox1"
                                    className="me-0"
                                    value="option1"
                                    label="Invoice this location"
                                    inline
                                  />
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow21}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow22}>
                      {t("AddLocWeeklySchedule")}
                    </MDBBtn>
                    <MDBModal
                      open={AddLocationWeekly}
                      setShow={setAddLocationWeekly}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addlocation")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow22}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("StreetAddress")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  placeholder="Suite, unit, building..."
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("City")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Grants Pass"
                                />
                              </div>
                              <div className="row pt-3">
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    <strong>{t("State")}</strong>
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Oregon"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    <strong>{t("ZIPCode")}</strong>
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="95727"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="tel-numbers pt-3">
                                <strong>{t("PrimaryContact")}</strong>
                              </div>
                              <div className="row pt-2">
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    {t("firstName")}
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Jerome"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    {t("lastName")}
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Friesenhahn"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("email")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Jerome@panterranetworks.com "
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="541 856 9547"
                                />
                              </div>
                              <div className="routing-border my-2"> </div>

                              <div className="tel-numbers mt-1">
                                <strong>{t("911Information")}</strong>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("en911services")}
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("UsePrimaryCont")}
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="tel-numbers mt-2">
                                {t("UsePrimaryCont")}
                              </div>
                              <MDBSelect
                                className=" mt-2"
                                data={[
                                  { text: "One", value: 1 },
                                  { text: "Two", value: 2 },
                                  { text: "Three", value: 3 },
                                  { text: "Four", value: 4 },
                                  { text: "Five", value: 5 },
                                  { text: "Six", value: 6 },
                                  { text: "Seven", value: 7 },
                                  { text: "Eight", value: 8 },
                                ]}
                              />
                              <div className="tel-numbers mt-2">
                                {t("Speclocation")}
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  placeholder="Frontdesk, Server Room, etc.."
                                />
                              </div>
                              <div className="routing-border my-2"></div>

                              <div className="tel-numbers mt-1">
                                <strong>{t("weeklyschedule")}</strong>
                              </div>
                              <div className="mt-1">
                                <MDBRadio
                                  name="inlineRadio"
                                  id="inlineRadio1"
                                  value="option1"
                                  label="24/7"
                                  inline
                                />
                                <MDBRadio
                                  name="inlineRadio"
                                  id="inlineRadio2"
                                  value="option2"
                                  label="Weekly Schedule"
                                  inline
                                />
                              </div>

                              <div className="tel-numbers mt-2">
                                <strong>{t("billingGroup")}</strong>
                              </div>
                              <div className="form mt-1 d-flex w-100 justify-content-between align-items-center">
                                <div className="w-50">
                                  <select
                                    className="form-select form-control w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">
                                      Prestige Worldwide
                                    </option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                                <div>
                                  <MDBCheckbox
                                    className="me-0"
                                    name="inlineCheck"
                                    id="inlineCheckbox1"
                                    value="option1"
                                    label="Invoice this location"
                                    inline
                                  />
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow22}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow23}>
                      {t("RemLocation")}
                    </MDBBtn>
                    <MDBModal
                      open={RemoveLocation}
                      setShow={setRemoveLocation}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("RemLocation")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow23}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div>
                                <span className="phrecording">
                                  {t("Locassociation")}
                                </span>
                              </div>
                              <div className="tel-numbers mt-3">
                                <strong>{t("selectLoctransfer")}</strong>
                              </div>
                              <span className="phrecording">
                                {t("billingsettings")}
                              </span>
                              <div className="w-100 mb-3">
                                <select
                                  className="form-select form-control w-100"
                                  name="San Jose"
                                >
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("select911loc")}</strong>
                              </div>
                              <span className="phrecording">
                                {t("Search911enloc")}
                              </span>
                              <div className="mb-0 w-100">
                                <div className="w-100">
                                  <select
                                    className="form-select form-control w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                                <MDBBtn className="mt-3 ml-0">
                                  <MDBIcon fas icon="plus" size="sm" /> {t("add911onlyloc")}
                                </MDBBtn>
                              </div>
                            </div>
                          </MDBModalBody>

                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow23}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow24}>
                      {t("moveaUser")}
                    </MDBBtn>
                    <MDBModal
                      open={MoveUserLocation}
                      setShow={setMoveUserLocation}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("Moveuserloc")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow24}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100 d-flex  align-items-center justify-content-center">
                              <div className="w-100">
                                <strong className=" d-block">
                                  {t("location")}
                                </strong>
                                <select
                                  className="form-select form-control w-100"
                                  name="San Jose"
                                >
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow24}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("Move")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow25}>
                      {t("Add911Loc")}
                    </MDBBtn>
                    <MDBModal
                      open={Add911Location}
                      setShow={setAdd911Location}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("Add911Loc")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow25}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                              </div>
                              <div className="form ">
                                <input
                                  type="text"
                                  className="w-60"
                                  value="jerome's Place"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("StreetAddress")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  placeholder="Suite, unit, building..."
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("City")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Grants Pass"
                                />
                              </div>

                              <div className="row pt-3">
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    <strong>{t("State")}</strong>
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Oregon"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    <strong>{t("ZIPCode")}</strong>
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="95727"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="tel-numbers mt-2">
                                <strong>{t("Speclocation")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Grants Pass"
                                />
                              </div>

                              <div className="tel-numbers mt-2">
                                <strong>{t("PrimaryContact")}</strong>
                              </div>
                              <div className="row pt-2">
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    {t("firstName")}
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Jerome"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="tel-numbers">
                                    {t("lastName")}
                                  </div>
                                  <div className="form">
                                    <input
                                      type="text"
                                      value="Friesenhahn"
                                      className="w-100"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("email")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="Jerome@panterranetworks.com "
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control w-100"
                                  value="541 856 9547"
                                />
                              </div>
                              <div className="routing-border my-2"> </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("dedicate911no")}</strong>
                              </div>
                              <select
                                className="form-select form-control w-100"
                                name="San Jose"
                              >
                                <option value="San Jose">
                                  --Select a Dedicated number for 911--
                                </option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                              <div className="tel-numbers mt-1">
                                <strong>{t("billingGroup")}</strong>
                              </div>
                              <select
                                className="form-select form-control w-100"
                                name="San Jose"
                              >
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow25}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow26}>
                      {t("Rem911Location")}
                    </MDBBtn>
                    <MDBModal
                      open={Remove911Location}
                      setShow={setRemove911Location}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("Rem911Location")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow26}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="px-2">
                                <span className="phrecording">
                                  {t("Rem911Locationtxt")}
                                </span>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("select911loc")}</strong>
                              </div>
                              <span className="phrecording">
                                {t("Search911enloc")}
                              </span>
                              <div className="form my-3 d-inline-flex w-100 justify-content-between">
                                <div className="w-50">
                                  <select
                                    className="form-select form-control w-100"
                                    name="San Jose"
                                  >
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                    <option value="San Jose">San Jose</option>
                                  </select>
                                </div>
                                <MDBBtn><MDBIcon fas icon="plus" size="sm" /> {t("add911onlyloc")}</MDBBtn>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow26}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="pt-4">{t("users")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow27}>
                      {t("ChangeCallerID")}
                    </MDBBtn>
                    <MDBModal
                      open={ChangeCallerID}
                      setShow={setChangeCallerID}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("ChangeCallerID")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow27}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <strong className=" d-block">
                                {t("callerID")}
                              </strong>
                              <select
                                className="form-select form-control w-100 mt-2"
                                name="408 702 2241"
                              >
                                <option value="San Jose">408 702 2241</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow27}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow28}>
                      {t("ChangeCallPermissions")}
                    </MDBBtn>
                    <MDBModal
                      open={ChangeCallingPermissions}
                      setShow={setChangeCallingPermissions}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("ChangeCallPermissions")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow28}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <strong className=" d-block">
                                {t("ChangePermissions")}
                              </strong>
                              <select
                                className="form-select form-control mt-2 w-100"
                                name="408 702 2241"
                              >
                                <option value="San Jose">
                                  International and Caribbean
                                </option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow28}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow29}>
                      {t("ChangeLoc")}
                    </MDBBtn>
                    <MDBModal
                      open={ChangeLocation}
                      setShow={setChangeLocation}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("ChangeLoc")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow29}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <strong className=" d-block">
                                {t("ChangeLoc")}
                              </strong>
                              <select
                                className="form-select form-control mt-2 w-100"
                                name="408 702 2241"
                              >
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">
                                  International and Caribbean
                                </option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow29}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow30}>
                      {t("ChangeBillingGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={ChangeBillingGroup}
                      setShow={setChangeBillingGroup}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("ChangeBillingGroup")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow30}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <strong className=" d-block">
                                {t("ChangeBillingGroup")}
                              </strong>
                              <select
                                className="form-select form-control mt-2 w-100"
                                name="408 702 2241"
                              >
                                <option value="San Jose">Default</option>
                                <option value="San Jose">Default</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow30}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow31}>
                      {t("EnDisaddOn")}
                    </MDBBtn>
                    <MDBModal
                      open={EnableorDisableanaddOn}
                      setShow={setEnableorDisableanaddOn}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("EnDisaddOn")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow31}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100">
                              <div>
                                <strong className=" d-block">
                                  {t("Add-On")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    {t("DigitalFaxUnlmited")}
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className="pt-2 phrecording">
                                {t("AddOnenable")}
                                <span className="green-text">3</span>
                                {t("users")}.
                              </div>
                              <div className=" phrecording">
                                {t("AddOnenabletxt")}
                                <span className="green-text"> $29.85.</span>
                              </div>

                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    <strong className=" d-block">
                                      {t("DigitalFaxUnlmited")}
                                    </strong>
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow31}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("ConfirmChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow32}>
                      {t("EnDisaddOn")}
                    </MDBBtn>
                    <MDBModal
                      open={EnableorDisableanaddOnOff}
                      setShow={setEnableorDisableanaddOnOff}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("ChangeBillingGroup")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow32}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100">
                              <div>
                                <strong className=" d-block">
                                  {t("Add-On")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    {t("DigitalFaxUnlmited")}
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className=" mt-2 phrecording">
                                Disabling This Add-On will be applied to
                                <span className="green-text">3</span> Users.
                              </div>

                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    <strong className=" d-block">
                                      {t("DigitalFaxUnlmited")}
                                    </strong>
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow32}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("ConfirmChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow33}>
                      {t("ChangeSeatPlan")}
                    </MDBBtn>
                    <MDBModal
                      open={ChangeSeatPlan}
                      setShow={setChangeSeatPlan}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("ChangeSeatPlan")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow33}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100">
                              <div>
                                <strong className=" d-block">
                                  {t("SeatPlan")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">Call Center</option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className="pt-2  phrecording">
                                {t("SeatPlantxt")}
                                <span className="green-text">3</span>
                                {t("users")}.
                              </div>
                              <div className="pt-2 phrecording">
                                <span className="green-text">3</span>
                                {t("CallCentertxt")}
                              </div>
                              <div className="pt-2 phrecording">
                                {t("increasemonthcost")}
                                <span className="green-text"> $134.85</span>.
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow33}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("ConfirmChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow34}>
                      {t("ChangePermissionRole")}
                    </MDBBtn>
                    <MDBModal
                      open={ChangePermissionRole}
                      setShow={setChangePermissionRole}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("ChangePermissionRole")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow34}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100 ">
                              <div>
                                <strong className=" d-block">
                                  {t("PermissionRole")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">Super Admin</option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className="pt-2  phrecording">
                                {t("ChangePermissionRoletxt")}
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow34}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("ConfirmChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow35}>
                      {t("ConfigWebInt")}
                    </MDBBtn>
                    <MDBModal
                      open={ConfigureWebIntegration}
                      setShow={setConfigureWebIntegration}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("ConfigWebInt")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow35}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="w-100">
                                <strong className=" d-block">
                                  {t("PermissionRole")}
                                </strong>
                                <span className="phrecording w-100">
                                  {t("PermissionRoletxt")}
                                </span>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    ACD Call accepted
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className="w-100">
                                <strong className=" mt-2 d-block">
                                  {t("URL")}
                                </strong>
                                <span className="phrecording w-100">
                                  {t("StreamsACDCall3rdpartywebapp", {"PRODUCT_NAME" : streamsProductName})}
                                </span>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    {streamsProductName} ACD Cal Deposirtion URL
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                              <div className="mt-2 add-numbermain">
                                <MDBTextArea
                                  value="https://streams.us/user/ACDCallDispositions.%20jsp%20callerid:%20$AcdCallerID$&.queuename=$QueueNameS&%20queuewaittime=$QueueWaitTimes&dnis=SDNIS$&cnam%20SCNAMS&transactionid=$Transactionid$&dnisaliasname=%20SDNISAlias$"
                                  rows={4}
                                  style={{ fontSize: "10px" }}
                                />
                                <MDBBtnGroup
                                  aria-label="Button group with nested dropdown"
                                  className="display-inline float-right mx-3"
                                >
                                  <MDBDropdown>
                                    <MDBDropdownToggle className="btn btn-primary green-button no-shadow">
                                      <MDBIcon fas icon="plus" size="sm" /> {t("AddURLKey")}
                                    </MDBDropdownToggle>
                                    <MDBDropdownMenu>
                                      <MDBDropdownItem link>
                                        {t("CallerID")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("AgentName")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("CNAM")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("DNIS")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("DNISAlias")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("QueueName")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("QueueWaitTime")}
                                      </MDBDropdownItem>
                                      <MDBDropdownItem link>
                                        {t("CallID")}
                                      </MDBDropdownItem>
                                    </MDBDropdownMenu>
                                  </MDBDropdown>
                                </MDBBtnGroup>
                              </div>

                              <strong className=" mt-2 d-block">
                                {t("Devicesapplyinteg")}
                              </strong>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("IpPhone")} 1
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("IpPhone")} 2
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div className="add-numbermain mt-2">
                                <div>
                                  <div className="tel-numbers">
                                    {t("StreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}
                                  </div>
                                </div>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <strong className=" mt-2 d-block">
                                {t("BrowserBehaviour")}
                              </strong>
                              <MDBTable className="w-100 mb-4">
                                <MDBTableBody>
                                  <tr>
                                    <td>
                                      <MDBCheckbox
                                        name="flexCheck1"
                                        value=""
                                        className="me-0"
                                        id="flexCheckDefault"
                                        label="New Tab"
                                        defaultChecked
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <MDBCheckbox
                                        name="flexCheck2"
                                        value=""
                                        className="me-0"
                                        id="flexCheckDefault2"
                                        label="Current Tab"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <MDBCheckbox
                                        name="flexCheck3"
                                        value=""
                                        className="me-0"
                                        id="flexCheckDefault3"
                                        label="No Browser"
                                      />
                                    </td>
                                  </tr>
                                </MDBTableBody>
                              </MDBTable>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow35}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow36}>
                      {t("AddToGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={AddToGroup}
                      setShow={setAddToGroup}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddToGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow36}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100">
                              <div className=" ">
                                <strong className=" d-block">
                                  {t("Group")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    Onboarding: User Group
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow36}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow37}>
                      {t("AddToGroup")} 2
                    </MDBBtn>
                    <MDBModal
                      open={AddToGroup2}
                      setShow={setAddToGroup2}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddToGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow37}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="w-100">
                              <div className=" ">
                                <strong className=" d-block">
                                  {t("Group")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    Sales: 5755: Hunt Group
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>

                              <div className=" mt-3">
                                <strong className=" d-block">
                                  {t("Group")}
                                </strong>
                                <span className="phrecording">
                                  {t("Groupusertxt")}
                                </span>
                                <select
                                  className="form-select form-control mt-1 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">

                                    User and Supervisor
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow37}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow38}>
                      {t("AddToGroup")} 3
                    </MDBBtn>
                    <MDBModal
                      open={AddToGroup3}
                      setShow={setAddToGroup3}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddToGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow38}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div>
                                <strong className=" d-block">
                                  {t("Group")}
                                </strong>
                                <select
                                  className="form-select form-control mt-2 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">
                                    SupportACD: 5805: ACD Queue
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>

                              <div className=" mt-2">
                                <strong className=" d-block">
                                  {t("Group")}
                                </strong>
                                <span className="phrecording">
                                  {t("Grouptxt")}
                                </span>
                                <select
                                  className="form-select form-control mt-1 w-100"
                                  name="408 702 2241"
                                >
                                  <option value="San Jose">

                                    Agent and Supervisor
                                  </option>
                                  <option value="San Jose">Default</option>
                                  <option value="San Jose">San Jose</option>
                                  <option value="San Jose">San Jose</option>
                                </select>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow38}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow39}>
                      {t("ResetPassword")}
                    </MDBBtn>
                    <MDBModal
                      open={ResetPassword}
                      setShow={setResetPassword}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("ResetPassword")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow39}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <span className="phrecording">
                                {t("ResetPasswordtxt")}
                              </span>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow39}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("ResetPassword")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow40}>
                      {t("sendWelcomeEmail")}
                    </MDBBtn>
                    <MDBModal
                      open={SendWelcomeEmail}
                      setShow={setSendWelcomeEmail}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("sendWelcomeEmail")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow40}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <span className="phrecording">
                                {t("sendWelcomeEmailtxt")}
                              </span>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow40}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("sendWelcomeEmail")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow41}>
                      {t("RemoveUser")}
                    </MDBBtn>
                    <MDBModal
                      open={RemoveUser}
                      setShow={setRemoveUser}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("RemoveUser")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow41}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <span className="phrecording">
                                {t("RemoveUsertxt")}
                              </span>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow41}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow42}>
                      <MDBIcon fas icon="plus" size="sm" />  {t("addExternal")}
                    </MDBBtn>
                    <MDBModal
                      open={AddExternalNumbers}
                      setShow={setAddExternalNumbers}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("addExternal")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow42}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("ExtNumberName")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Home Office"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="5418569547"
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow42}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow43}>
                      {t("EditExtNo")}
                    </MDBBtn>
                    <MDBModal
                      open={EditExternalNumbers}
                      setShow={setEditExternalNumbers}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("EditExtNo")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow43}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("ExtNumberName")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="Home Office"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="form-control"
                                  value="5418569547"
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow43}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("saveChanges")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow44}>
                      <MDBIcon fas icon="plus" size="sm" /> Add Speed Dial
                    </MDBBtn>
                    <MDBModal
                      open={AddSpeedDial}
                      setShow={setAddSpeedDial}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddSpeedDial")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow44}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("AddSpeedDialNo")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="1"
                                />
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("name")}</strong>
                              </div>
                              <div className="form mt-2">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="tel-numbers mt-2">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="5418569547"
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow44}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow45}>
                      {t("EditSpeedDialNo")}
                    </MDBBtn>
                    <MDBModal
                      open={EditSpeedDial}
                      setShow={setEditSpeedDial}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddSpeedDial")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow45}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("EditSpeedDialNo")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="1"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("name")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="Prestige Worldwide"
                                />
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="5418569547"
                                />
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow45}>
                              {t("cancel")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBPopconfirm placement="bottom" btnChildren="Add Filter">
                      <MDBPopconfirmMessage>
                        <p className="fw-bold mb-1">{t("FilterBy")}</p>
                        <div className="routing-border"></div>
                        <div className="px-3 mt-2">
                          <MDBPopconfirm
                            placement="right"
                            btnClassName="ms-3"
                            btnChildren="Seat Plan"
                          >
                            <MDBPopconfirmMessage className="ms-5"></MDBPopconfirmMessage>
                          </MDBPopconfirm>
                        </div>
                        <div className="px-3 mt-2">
                          <MDBPopconfirm
                            placement="right"
                            btnClassName="ms-3"
                            btnChildren="Role"
                            className="mt-3"
                          >
                            <MDBPopconfirmMessage className="ms-5"></MDBPopconfirmMessage>
                            <MDBCheckbox
                              className="me-0"
                              name="flexCheck"
                              value=""
                              id="flexCheckDefault"
                              label="Default checkbox"
                            />
                            <MDBCheckbox
                              className="me-0"
                              name="flexCheck"
                              value=""
                              id="flexCheckChecked"
                              label="Checked checkbox"
                              defaultChecked
                            />
                          </MDBPopconfirm>
                        </div>
                      </MDBPopconfirmMessage>
                    </MDBPopconfirm>

                    <MDBBtn className="m-2" onClick={toggleShow46}>
                      {t("AddUserGroup")}
                    </MDBBtn>
                    <MDBModal
                      open={AddUserGroup}
                      setShow={setAddUserGroup}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddUserGroup")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow46}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                                <div className="form pt-1">
                                  <input
                                    type="text"
                                    className="w-100"
                                    value="Onboarding"
                                  />
                                </div>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Description")}</strong>
                                <div className="form pt-1">
                                  <MDBTextArea
                                    id="textAreaExample"
                                    className="w-100"
                                    rows={4}
                                    value="Department of Onboarding"
                                  />
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow46}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="mt-4">{t("ViewRoutingPlan")}</h4>
                    <MDBBtn className="m-2" onClick={toggleShow47}>
                      {t("ViewRoutingPlan")}
                    </MDBBtn>
                    <MDBModal
                      open={RoutingPlans}
                      setShow={setRoutingPlans}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent>
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("ViewRoutingPlan")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow47}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="add-numbermain">
                                <div className="d-flex align-items-center">
                                  <div className="tel-numbers fs-6">
                                    {t("RoutingPlanName")}
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control w-50 p-1 ms-2"
                                    value="All Devices"
                                    disabled
                                  />
                                </div>
                                <div className="btn btn-primary">
                                  <MDBIcon far icon="clone" className="me-2" />
                                  {t("CloneRoutingPlan")}
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-start mt-4">
                                <div className="sequence">
                                  <div className="sequenceheader">
                                    <span className="d-flex align-items-center">
                                      <label className="fw-bold fs-5">
                                        {t("sequence")} 1
                                      </label>
                                      <MDBBtn
                                        size="sm"
                                        className="buttonsize mx-2"
                                      >
                                        <MDBIcon fas icon="plus" size="sm" /> {t("addDevice")}
                                      </MDBBtn>
                                    </span>
                                    <MDBBtn size="sm" className="buttonsize">
                                      <MDBIcon fas icon="ellipsis-v" />
                                    </MDBBtn>
                                  </div>
                                  <div className="ringtime ">
                                    <label>{t("RingTime")}</label>
                                    <span className="position-relative">
                                      <MDBInput
                                        label="20"
                                        id="form1"
                                        type="text"
                                      />
                                      <span className="seconds">
                                        {t("seconds")}
                                      </span>
                                    </span>
                                  </div>

                                  <div className="">
                                    <div className="sequenceheader">
                                      <label className="fw-bold">
                                        {t("IpPhone")} 1
                                      </label>
                                      <img
                                        src={remove}
                                        className="close-icon"
                                      />
                                    </div>

                                    <div className="mx-2">
                                      <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                        <label className="px-0 pe-2">
                                          {t("from")}
                                        </label>
                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <label className="px-2">
                                          {t("to")}
                                        </label>

                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <span className="ml-1">
                                          <MDBCheckbox
                                            className="me-0"
                                            name="flexCheck"
                                            value=""
                                            id="flexCheckDefault"
                                            label="24 hours"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="">
                                    <div className="sequenceheader">
                                      <label className="fw-bolder">
                                        {t("IpPhone")} 2
                                      </label>
                                      <img
                                        src={remove}
                                        className="close-icon"
                                      />
                                    </div>

                                    <div className="mx-2">
                                      <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                        <label className="px-0 pe-2">
                                          {t("from")}
                                        </label>
                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <label className="px-2">
                                          {t("to")}
                                        </label>

                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <span className="ml-1">
                                          <MDBCheckbox
                                            className="me-0"
                                            name="flexCheck"
                                            value=""
                                            id="flexCheckDefault"
                                            label="24 hours"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="">
                                    <div className="sequenceheader">
                                      <label className="fw-bold">
                                        {t("StreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}
                                      </label>
                                      <img
                                        src={remove}
                                        className="close-icon"
                                      />
                                    </div>

                                    <div className="mx-2">
                                      <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                        <label className="px-0 pe-2">
                                          {t("from")}
                                        </label>
                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <label className="px-2">
                                          {t("to")}
                                        </label>

                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <span className="ml-1">
                                          <MDBCheckbox
                                            className="me-0"
                                            name="flexCheck"
                                            value=""
                                            id="flexCheckDefault"
                                            label="24 hours"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="sequenceheader">
                                      <label className="fw-bold">
                                        {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                      </label>
                                      <img
                                        src={remove}
                                        className="close-icon"
                                      />
                                    </div>

                                    <div className="mx-2">
                                      <div className="w-100 d-flex justify-content-between align-items-center py-3 bottomline mb-2">
                                        <label className="px-0 pe-2">
                                          {t("from")}
                                        </label>
                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <label className="px-2">
                                          {t("to")}
                                        </label>

                                        <select
                                          name="09:10 AM"
                                          id="09:10 AM"
                                          className="form-control selectdate"
                                        >
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                          <option value="09:10 AM">
                                            09:10 AM
                                          </option>
                                        </select>
                                        <span className="ml-1">
                                          <MDBCheckbox
                                            className="me-0"
                                            name="flexCheck"
                                            value=""
                                            id="flexCheckDefault"
                                            label="24 hours"
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <img src={arrow} className="w_100px" />
                                </div>
                                <div className="sequence-small">
                                  <div className="sequenceheader d-flex flex-column align-items-center">
                                    <label className="fw-bold  fs-5">
                                      {t("Voicemail")}
                                    </label>
                                    <div>
                                      <img src={voicemail} className="mb-2" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow47}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("Move")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow48}>
                      {t("AddDeviceSequence")}
                    </MDBBtn>
                    <MDBModal
                      open={AddSequenceButton}
                      setShow={setAddSequenceButton}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("AddDeviceSequence")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow48}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="phoneselect my-1">
                              <select
                                className="form-select form-control"
                                name="San Jose"
                              >
                                <option value="San Jose">
                                  {t("SelectDevices")}
                                </option>
                                <option value="San Jose">
                                  {t("IpPhone")} 1
                                </option>
                                <option value="San Jose">
                                  {t("IpPhone")} 2
                                </option>
                                <option value="San Jose">
                                  {t("StreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}
                                </option>
                                <option value="San Jose">
                                  {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                </option>
                                <option value="San Jose">
                                  Call Phone: 661 863 8829
                                </option>
                                <option value="San Jose">
                                  Home Office: 541 856 9547
                                </option>
                                <option value="San Jose">Edit a Number</option>
                              </select>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-3">
                              <label className="px-0 pe-2 pt-2">
                                {t("from")}
                              </label>
                              <MDBSelect className="w-30"
                                data={[
                                  { text: "9:00 AM", value: 1 },
                                  { text: "9:00 AM", value: 1 },
                                  { text: "9:00 AM", value: 1 },
                                ]}
                              />
                              <label className=" px-2 pt-2">{t("to")}</label>
                              <MDBSelect className="w-30"
                                data={[
                                  { text: "6:00 PM", value: 1 },
                                  { text: "6:00 PM", value: 1 },
                                  { text: "6:00 PM", value: 1 },
                                ]}
                              />
                              <MDBCheckbox
                                className="me-0"
                                name="flexCheck"
                                value=""
                                id="flexCheckDefault"
                                label="24 hours"
                              />
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow48}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>




                    <MDBBtn className="m-2" onClick={toggleShow54}>
                      {t("AddDeviceSequence")} Checked
                    </MDBBtn>
                    <MDBModal
                      open={AddSequence}
                      setShow={setAddSequence}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("AddDeviceSequence")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow54}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="phoneselect my-1">
                              <select
                                className="form-select form-control"
                                name="San Jose"
                              >
                                <option value="San Jose">
                                  {t("SelectDevices")}
                                </option>
                                <option value="San Jose">
                                  {t("IpPhone")} 1
                                </option>
                                <option value="San Jose">
                                  {t("IpPhone")} 2
                                </option>
                                <option value="San Jose">
                                  {t("StreamsDesktop", {"PRODUCT_NAME" : streamsProductName})}
                                </option>
                                <option value="San Jose">
                                  {t("StreamsMobile", {"PRODUCT_NAME" : streamsProductName})}
                                </option>
                                <option value="San Jose">
                                  Call Phone: 661 863 8829
                                </option>
                                <option value="San Jose">
                                  Home Office: 541 856 9547
                                </option>
                                <option value="San Jose">Edit a Number</option>
                              </select>
                            </div>






                            <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
                              <div className="tel-numbers fw-bold">{t("name")}</div>
                              <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel' value='' aria-label='...' label='Save' />
                            </div>
                            <div className="w-100">
                              <input
                                type="text"
                                value="Prestige Worldwide"
                                className="selectname form-control w-100"
                              />
                            </div>

                            <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
                              <div className="tel-numbers fw-bold">{t("Number")}</div>
                            </div>
                            <div className="w-100">
                              <input
                                type="text"
                                value="5148569547"
                                className="selectname form-control w-100"
                              />
                            </div>


                            <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
                              <div className="tel-numbers fw-bold">{t("CallerIDpasstrough")}</div>
                              <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel' value='' aria-label='...' />
                            </div>
                            <div className="phoneselect mt-1">
                              <select
                                className="form-control form-select selectname"
                                name="Default"
                              >
                                <option value="San Jose">Choose Caller ID...</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>




















                            <div className="d-flex align-items-center justify-content-between mt-3">
                              <label className="px-0 pe-2 pt-2">
                                {t("from")}
                              </label>
                              <MDBSelect className="w-30"
                                data={[
                                  { text: "9:00 AM", value: 1 },
                                  { text: "9:00 AM", value: 1 },
                                  { text: "9:00 AM", value: 1 },
                                ]}
                              />
                              <label className=" px-2 pt-2">{t("to")}</label>
                              <MDBSelect className="w-30"
                                data={[
                                  { text: "6:00 PM", value: 1 },
                                  { text: "6:00 PM", value: 1 },
                                  { text: "6:00 PM", value: 1 },
                                ]}
                              />
                              <MDBCheckbox
                                className="me-0"
                                name="flexCheck"
                                value=""
                                id="flexCheckDefault"
                                label="24 hours"
                              />
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow54}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>
















                    <MDBBtn className="m-2" onClick={toggleShow49}>
                      {t("AddTeamButton")}
                    </MDBBtn>
                    <MDBModal
                      open={AddTeamButton}
                      setShow={setAddTeamButton}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddTeam")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow49}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                                <div className="form pt-1">
                                  <input
                                    type="text"
                                    className="form-control w-100"
                                    value="Telephony Team"
                                  />
                                </div>
                              </div>

                              <div className="w-100 mt-3">
                                <strong className=" d-block">
                                  {t("Type")}
                                </strong>
                                <select
                                  className="form-select form-control mt-1 w-100"
                                  name="Public"
                                >
                                  <option value="San Jose"> Public</option>
                                  <option value="San Jose">Public</option>
                                  <option value="San Jose">Public</option>
                                  <option value="San Jose">Public</option>
                                </select>
                              </div>

                              <div className="w-100 mt-3">
                                <strong className=" d-block">
                                  {t("Accessibility")}
                                </strong>
                                <select
                                  className="form-select form-control mt-1 w-100"
                                  name="Public"
                                >
                                  <option value="San Jose">

                                    Only Admin Can Invite
                                  </option>
                                  <option value="San Jose">Public</option>
                                  <option value="San Jose">Public</option>
                                  <option value="San Jose">Public</option>
                                </select>
                              </div>

                              <div className="add-numbermain mt-3">
                                <strong className=" d-block">
                                  {t("EnableContributor")}
                                </strong>

                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="add-numbermain mt-1">
                                <strong className=" d-block">
                                  {t("HideTeamMembers")}
                                </strong>

                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow49}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow50}>
                      {t("AdduseranotherAccount")}
                    </MDBBtn>
                    <MDBModal
                      open={AddUserFromAnotherAccount}
                      setShow={setAddUserFromAnotherAccount}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("AdduseranotherAccount")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow50}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("email_address")}</strong>
                              </div>
                              <div className="form pt-1">
                                <input
                                  type="text"
                                  className="w-100"
                                  value="jerome@panterranetworks.com"
                                />
                              </div>
                              <div className="row pt-4">
                                <div className="w-50">
                                  <strong>{t("User")}</strong>
                                  <p className="pt-1">Johnny Brgood</p>
                                </div>
                                <div className="w-50">
                                  <strong>{t("Account")}</strong>
                                  <p className="pt-1">Johnny Brgood</p>
                                </div>
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow50}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow51}>
                      {t("AddAdminRole")}
                    </MDBBtn>
                    <MDBModal
                      open={AddAdminRole}
                      setShow={setAddAdminRole}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>{t("AddAdminRole")}</MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow51}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <div className="tel-numbers">
                                <strong>{t("name")}</strong>
                                <div className="form pt-1">
                                  <input
                                    type="text"
                                    className="w-100"
                                    value="PNW Admin"
                                  />
                                </div>
                              </div>
                              <div className="tel-numbers mt-1">
                                <strong>{t("Description")}</strong>
                                <div className="form pt-1">
                                  <MDBTextArea
                                    id="textAreaExample"
                                    className="w-100"
                                    rows={2}
                                    value="Admin Role for PNW"
                                  />
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">{t("ManageSeats")}</p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">
                                  {t("AddDelEditUsers")}
                                </p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">
                                  {t("Adddeleditaccfeat")}
                                </p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">{t("ManageAdmins")}</p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">
                                  {t("Accessuserdatareports")}
                                </p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">
                                  {t("Accessusercallrec")}
                                </p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">
                                  {t("AdddeleditPermissionRoles")}
                                </p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <p className=" d-block">
                                  {t("Accessbillingsect")}
                                </p>
                                <div className="phoneselect">
                                  <label className="switch">
                                    <input className="form-control" type="checkbox" />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>

                              <div className="tel-numbers mt-2 ">
                                <p className=" d-block">{t("location")}</p>
                                <div className="d-flex mt-2">
                                  <MDBRadio
                                    name="inlineRadio"
                                    id="inlineRadio1"
                                    value="option1"
                                    label="All Location"
                                    inline
                                  />
                                  <MDBRadio
                                    name="inlineRadio"
                                    id="inlineRadio2"
                                    value="option2"
                                    label="Select Location"
                                    inline
                                  />
                                </div>
                              </div>
                              <div className=" mt-2 d-flex justify-content-end w-100">
                                <MDBBtn
                                  className="green-button "
                                  data-mdb-toggle="modal"
                                  data-mdb-target="#exampleModal"
                                >
                                  <MDBIcon fas icon="plus" size="sm" /> {t("addlocation")}
                                </MDBBtn>
                              </div>
                              <MDBDatatable sortField="Name" 
                                data={advancedData}
                                pagination={false}
                                className="mt-2"
                              />
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow51}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("add")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={toggleShow52}>
                      {t("RemoveAdminRole")}
                    </MDBBtn>
                    <MDBModal
                      open={RemoveAdminRole}
                      setShow={setRemoveAdminRole}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("RemoveAdminRole")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShow52}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div>
                              <span className="phrecording ">
                                {t("RemoveAdminRoletxt")}
                              </span>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShow52}>
                              {t("close")}
                            </MDBBtn>
                            <MDBBtn>{t("remove")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <MDBBtn className="m-2" onClick={TabSwitch}>
                      {t("TabSwitch")}
                    </MDBBtn>
                    <MDBModal
                      open={TabSwitchWarn}
                      setShow={setTabSwitchWarn}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("Warning")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={TabSwitch}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>
                            <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                              <MDBIcon fas icon="exclamation-triangle" className="me-3 fs-5 mt-1" color="warning" />
                              <div>
                                There are unsaved changes. Are you sure you want to navigate away?
                              </div>
                            </div>
                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={TabSwitch}>
                              {t("cancle")}
                            </MDBBtn>
                            <MDBBtn>{t("ok")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>

                    <h4 className="mt-4">Include Users External Numbers</h4>


                    <MDBBtn className="m-2" onClick={toggleShowConfirm}>
                      Enabling Users External Numbers
                    </MDBBtn>
                    <MDBModal
                      open={ConfirmUserChanges}
                      setShow={setConfirmUserChanges}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("confirmUserChanges")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShowConfirm}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>

                            <div className='mt-2 d-flex align-itemd-center justify-content-between w-100'>
                              <div className="tel-numbers fw-bold">{t("CallerIDpasstrough")}</div>
                              <MDBCheckbox name='checkNoLabel' id='checkboxNoLabel' value='' aria-label='...' />
                            </div>
                            <div className="phoneselect mt-1">
                              <select
                                className="form-control form-select selectname"
                                name="Default"
                                disabled
                              >
                                <option value="San Jose">Choose Caller ID...</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                                <option value="San Jose">San Jose</option>
                              </select>
                            </div>
                            <p className="mt-4 text-secondary">{t("confirmUserChangestxt")}</p>

                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShowConfirm}>
                              {t("cancle")}
                            </MDBBtn>
                            <MDBBtn>{t("ok")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>


                    <MDBBtn className="m-2" onClick={toggleShowConfirm2}>
                      Disable Users External Numbers
                    </MDBBtn>
                    <MDBModal
                      open={ConfirmUserChanges2}
                      setShow={setConfirmUserChanges2}
                      tabIndex="-1"
                    >
                      <MDBModalDialog>
                        <MDBModalContent className="small-popup">
                          <MDBModalHeader>
                            <MDBModalTitle>
                              {t("confirmUserChanges")}
                            </MDBModalTitle>
                            <MDBBtn
                              className="btn-close"
                              color="none"
                              onClick={toggleShowConfirm2}
                            ></MDBBtn>
                          </MDBModalHeader>
                          <MDBModalBody>


                            <p className="text-secondary">{t("confirmUserChangestxt")}</p>

                          </MDBModalBody>
                          <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={toggleShowConfirm2}>
                              {t("cancle")}
                            </MDBBtn>
                            <MDBBtn>{t("ok")}</MDBBtn>
                          </MDBModalFooter>
                        </MDBModalContent>
                      </MDBModalDialog>
                    </MDBModal>



                  </div>
                </div>
              </section>
            </>
          }
        />
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

export default IpPopups;
